export const agb = [
  {
    title: 'Haftungsausschluss',
    paragraphTitleH5: '1. Inhalt des Onlineangebotes',
    text: [
      'E.DIS übernimmt keinerlei Gewähr für die Aktualität, Korrektheit, Vollständigkeit oder Qualität der bereitgestellten Informationen. Haftungsansprüche gegen E.DIS, welche sich auf Schäden materieller oder ideeller Art beziehen, die durch die Nutzung oder Nichtnutzung der dargebotenen Informationen bzw. durch die Nutzung fehlerhafter und unvollständiger Informationen verursacht wurden, sind grundsätzlich ausgeschlossen, sofern seitens E.DIS kein nachweislich vorsätzliches oder grob fahrlässiges Verschulden vorliegt.',
      'Alle Angebote sind freibleibend und unverbindlich. E.DIS behält es sich ausdrücklich vor, Teile der Seiten oder das gesamte Angebot ohne gesonderte Ankündigung zu verändern, zu ergänzen, zu löschen oder die Veröffentlichung zeitweise oder endgültig einzustellen.',
    ],
  },
  {
    paragraphTitleH5: '2. Verweise und Links',
    text: [
      "Bei direkten oder indirekten Verweisen auf fremde Webseiten ('Hyperlinks'), die außerhalb des Verantwortungsbereiches von E.DIS liegen, würde eine Haftungsverpflichtung ausschließlich in dem Fall in Kraft treten, in dem E.DIS von den Inhalten Kenntnis hat und es ihr technisch möglich und zumutbar wäre, die Nutzung im Falle rechtswidriger Inhalte zu verhindern.",
      'E.DIS erklärt hiermit ausdrücklich, dass zum Zeitpunkt der Linksetzung keine illegalen Inhalte auf den zu verlinkenden Seiten erkennbar waren. Auf die aktuelle und zukünftige Gestaltung, die Inhalte oder die Urheberschaft der verlinkten/verknüpften Seiten hat E.DIS keinerlei Einfluss. Deshalb distanziert sie sich hiermit ausdrücklich von allen Inhalten aller verlinkten /verknüpften Seiten, die nach der Linksetzung verändert wurden. Diese Feststellung gilt für alle innerhalb des eigenen Internetangebotes gesetzten Links und Verweise sowie für Fremdeinträge in von E.DIS eingerichteten Gästebüchern, Diskussionsforen, Linkverzeichnissen, Mailinglisten und in allen anderen Formen von Datenbanken, auf deren Inhalt externe Schreibzugriffe möglich sind. Für illegale, fehlerhafte oder unvollständige Inhalte und insbesondere für Schäden, die aus der Nutzung oder Nichtnutzung solcherart dargebotener Informationen entstehen, haftet allein der Anbieter der Seite, auf welche verwiesen wurde, nicht derjenige, der über Links auf die jeweilige Veröffentlichung lediglich verweist.',
    ],
  },
  {
    paragraphTitleH5: '3. Urheber- und Kennzeichenrecht',
    text: [
      'E.DIS ist bestrebt, in allen Publikationen die Urheberrechte der verwendeten Bilder, Grafiken, Tondokumente, Videosequenzen und Texte zu beachten, von ihr selbst erstellte Bilder, Grafiken, Tondokumente, Videosequenzen und Texte zu nutzen oder auf lizenzfreie Grafiken, Tondokumente, Videosequenzen und Texte zurückzugreifen.',
      'Alle innerhalb des Internetangebotes genannten und ggf. durch Dritte geschützten Marken- und Warenzeichen unterliegen uneingeschränkt den Bestimmungen des jeweils gültigen Kennzeichenrechts und den Besitzrechten der jeweiligen eingetragenen Eigentümer. Allein aufgrund der bloßen Nennung ist nicht der Schluss zu ziehen, dass Markenzeichen nicht durch Rechte Dritter geschützt sind!',
      'Das Copyright für veröffentlichte, von E.DIS selbst erstellte Objekte bleibt allein bei E.DIS. Eine Vervielfältigung oder Verwendung solcher Grafiken, Tondokumente, Videosequenzen und Texte in anderen elektronischen oder gedruckten Publikationen ist ohne ausdrückliche Zustimmung von E.DIS nicht gestattet.',
    ],
  },
  {
    paragraphTitleH5: '4. Datenschutz',
    text: [
      'Sofern innerhalb des Internetangebotes die Möglichkeit zur Eingabe persönlicher oder geschäftlicher Daten (E-Mail-Adressen, Namen, Anschriften) besteht, so erfolgt die Preisgabe dieser Daten seitens des Nutzers auf ausdrücklich freiwilliger Basis. Die Inanspruchnahme und Bezahlung aller angebotenen Dienste ist - soweit technisch möglich und zumutbar - auch ohne Angabe solcher Daten bzw. unter Angabe anonymisierter Daten oder eines Pseudonyms gestattet. Die Nutzung der im Rahmen des Impressums oder vergleichbarer Angaben veröffentlichten Kontaktdaten wie Postanschriften, Telefon- und Faxnummern sowie E-Mail-Adressen durch Dritte zur Übersendung von nicht ausdrücklich angeforderten Informationen ist nicht gestattet. Rechtliche Schritte gegen die Versender von sogenannten Spam-Mails bei Verstößen gegen dieses Verbot sind ausdrücklich vorbehalten.',
    ],
  },
  {
    paragraphTitleH5: '5. Rechtswirksamkeit dieses Haftungsausschlusses',
    text: [
      'Dieser Haftungsausschluss ist als Teil des Internetangebotes zu betrachten, von dem aus auf diese Seite verwiesen wurde. Sofern Teile oder einzelne Formulierungen dieses Textes der geltenden Rechtslage nicht, nicht mehr oder nicht vollständig entsprechen sollten, bleiben die übrigen Teile des Dokumentes in ihrem Inhalt und ihrer Gültigkeit davon unberührt.',
    ],
  },
];

export const impressum1 = [
  {
    title: 'Impressum',
    paragraphTitleH5: 'E.DIS Netz GmbH',
    text: [
      'Langewahler Straße 60',
      '15517 Fürstenwalde/Spree',
      'kundenservice@e-dis.de',
      'Sitz Fürstenwalde/Spree',
      'Amtsgericht Frankfurt (Oder) HRB 16068',
      'Umsatzsteueridentifikationsnummer DE285351013',
    ],
  },
];

export const impressum2 = [
  {
    paragraphTitleH5: 'Geschäftsführung',
    text: ['Stefan Blache', 'Harald Bock', 'Michael Kaiser'],
  },
];

export const impressum3 = [
  {
    text: ['Sollten Sie noch Fragen haben, können Sie sich jederzeit an uns wenden.'],
  },
];

export const dataProtection1 = [
  {
    title: 'Datenschutz',
    paragraphTitleH2: 'Datenschutzhinweise',
    text: [
      'Hier stellen wir Ihnen alle wichtigen Informationen zusammen: Hier können Sie unsere Online-Datenschutzprinzipien nachlesen und warum wir aus bestimmten Gründen Daten erheben.',
    ],
  },
];

export const dataProtection2 = [
  {
    paragraphTitleH2: 'Informationsschreiben für Betroffene',
    text: [
      'Hier finden Sie die entsprechenden Datenschutzhinweise für unterschiedlichen Betroffenengruppen. So wissen Sie Bescheid, welche Daten wir von Ihnen zu welchen Zwecken verarbeiten.',
    ],
  },
];
